// Calculator Formatters Module
// Utility functions for formatting calculator values

// Utility functions for formatting
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.ceil(amount));
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(Math.ceil(num));
}

export function formatPercentage(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

export function formatRange(min: number, max: number, formatter: (n: number) => string): string {
  return `${formatter(min)} - ${formatter(max)}`;
}

export function formatCurrencyRange(min: number, max: number): string {
  return formatRange(min, max, formatCurrency);
}

export function formatNumberRange(min: number, max: number): string {
  return formatRange(min, max, formatNumber);
}

// Additional formatting utilities previously in format-utils
export function formatDate(date: Date | string): string {
  // If we receive an ISO date string (YYYY-MM-DD), format without constructing a Date
  if (typeof date === 'string') {
    const m = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const [_, y, mm, dd] = m;
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const monthName = months[parseInt(mm, 10) - 1] || mm;
      return `${monthName} ${parseInt(dd, 10)}, ${y}`;
    }
  }

  // Fallback: format using UTC to avoid timezone shifts on midnight
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatPrice(price: number): string {
  return formatCurrency(price);
}

export function formatFollowerCount(count: number): string {
  if (count >= 1000000) {
    return Math.ceil(count / 1000000) + 'M';
  } else if (count >= 1000) {
    return Math.ceil(count / 1000) + 'K';
  }
  return Math.ceil(count).toLocaleString();
}

export function formatImpressionCount(count: number): string {
  if (count >= 1000000) {
    return (count / 1000000).toFixed(1) + 'M';
  } else if (count >= 1000) {
    return (count / 1000).toFixed(1) + 'K';
  }
  return Math.ceil(count).toLocaleString();
}

export function formatEngagementRate(rate: number): string {
  return (rate * 100).toFixed(1) + '%';
}
